
import { useTranslations } from "use-intl";
import InvoiceUploadForm from "@/components/invoices/InvoiceUploadForm";

const InvoiceUpload = () => {
  const t = useTranslations("consultantInvoiceCreate.upload");
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">{t("pageTitle")}</h1>
      <p className="text-muted-foreground">
        {t("pageSubtitle")}
      </p>

      <InvoiceUploadForm />
    </div>
  );
};

export default InvoiceUpload;
